import { Component, AfterViewInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMAGE_STYLES, BackgroundStyle } from '@app/constants';
import { PlatformService } from '@app/data';

@Component({
  selector: 'app-media',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.less']
})
export class MediaComponent implements AfterViewInit {

  @Input() kind: BackgroundStyle = 'default';
  @Input() alt?: string;
  @Input() src?: string = '';
  @Input() loading: 'lazy' | 'eager' = 'lazy';
  @Input() position: 'top' | 'center' | 'bottom' = 'center';

  public $src = new BehaviorSubject<string>('');
  public $srcset = new BehaviorSubject<string>('');
  public $sizes = new BehaviorSubject<string>('');
  public strategy = this.platform.isBrowser ? 'local' : 'global';
  public $loaded = new BehaviorSubject<boolean>(false);

  constructor(
    private platform: PlatformService
  ) {}

  ngAfterViewInit():void {
    //console.log('MediaComponent ngAfterViewInit this.src ', this.src);

    if (this.src && this.kind !== 'default') {

      const src = this.getSrc(this.src);
      const srcset = this.getSrcset(this.src);
      const sizes = this.getSizes(this.kind);

      this.$src.next(src);
      this.$srcset.next(srcset);
      this.$sizes.next(sizes);

      //console.log('MediaComponent ngAfterViewInit src ', src);
      //console.log('MediaComponent ngAfterViewInit srcset ', srcset);
      //console.log('MediaComponent ngAfterViewInit sizes ', sizes);
    }
    else if (this.src && this.kind === 'default') {
      this.$src.next(this.src);
    }
  }

  private getSrc = (src: string): string => src.replace('/default/files/', '/default/files/styles/background_300/public/');

  private getSrcset = (src: string): string => {
    let srcset = [];

    const webpStyles = IMAGE_STYLES.background_sizes_webp;

    for (var i = 0; i < webpStyles.length; ++i) {
      let webpSrc = src.replace(IMAGE_STYLES.replace_pattern, webpStyles[i]);
      webpSrc = webpSrc.replace('.jpg', '.jpg.webp');
      webpSrc = webpSrc + ' ' + IMAGE_STYLES.backround_sizes_img[i];
      srcset.push(webpSrc);
    }

    return srcset.join(', ');
  };
  
  private getSizes = (kind: BackgroundStyle): string => IMAGE_STYLES.backround_sizes[kind];
  
  public imageLoaded = ($event: any): void => {
    //console.log('MediaComponent imageLoaded $event ', $event);

    this.$loaded.next(true);
  };
}
